var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-cube",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25,25)"
  }, /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{config.dp}}",
    "ng-attr-y": "{{config.dp}}",
    "ng-attr-width": "{{config.blockSize}}",
    "ng-attr-height": "{{config.blockSize}}",
    "ng-attr-fill": "{{config.c1}}",
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#337ab7",
    transform: "scale(1.07044 1.07044)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    calcMode: "spline",
    values: "1.5;1",
    keyTimes: "0;1",
    dur: "1s",
    keySplines: "0 0.5 0.5 1",
    begin: "-0.3s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75,25)"
  }, /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{config.dp}}",
    "ng-attr-y": "{{config.dp}}",
    "ng-attr-width": "{{config.blockSize}}",
    "ng-attr-height": "{{config.blockSize}}",
    "ng-attr-fill": "{{config.c2}}",
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#d9534f",
    transform: "scale(1.10457 1.10457)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    calcMode: "spline",
    values: "1.5;1",
    keyTimes: "0;1",
    dur: "1s",
    keySplines: "0 0.5 0.5 1",
    begin: "-0.2s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25,75)"
  }, /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{config.dp}}",
    "ng-attr-y": "{{config.dp}}",
    "ng-attr-width": "{{config.blockSize}}",
    "ng-attr-height": "{{config.blockSize}}",
    "ng-attr-fill": "{{config.c3}}",
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#5cb85c",
    transform: "scale(1.20002 1.20002)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    calcMode: "spline",
    values: "1.5;1",
    keyTimes: "0;1",
    dur: "1s",
    keySplines: "0 0.5 0.5 1",
    begin: "0s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75,75)"
  }, /*#__PURE__*/React.createElement("rect", {
    "ng-attr-x": "{{config.dp}}",
    "ng-attr-y": "{{config.dp}}",
    "ng-attr-width": "{{config.blockSize}}",
    "ng-attr-height": "{{config.blockSize}}",
    "ng-attr-fill": "{{config.c4}}",
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    fill: "#f0ad4e",
    transform: "scale(1.14711 1.14711)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    calcMode: "spline",
    values: "1.5;1",
    keyTimes: "0;1",
    dur: "1s",
    keySplines: "0 0.5 0.5 1",
    begin: "-0.1s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.19db0b4297ae57a65931af02a2f4726c.svg";
export { ForwardRef as ReactComponent };